const Constants = Object.freeze({
  // ---------------------------- HOME ----------------------------
  TIME_ON: "Tempo ligado: ",
  NUM_OF_DEVICES: "Número de dispositivos",
  MASTERS: "Mestres",
  SLAVES: "Escravos",
  STATISTICS: "Estatísticas",

  NO_RETRIES: "Sem retentativas",

  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  CYCLE_TIME_S: "TEMPO DE CICLO (s)",
  CYCLE_TIME_MS: "TEMPO DE CICLO (ms)",

  WATCHDOG_MS: "WATCHDOG (ms)",

  RETRIES_LIMIT: "LIMITE DE RETENTATIVA",

  PROFIBUS_NETWORK_INFO: "Informações da rede PROFIBUS",

  HSA_POPUP_1: "HSA (Highest PROFIBUS Address) é o parâmetro que indica o maior endereço que o mestre realiza a busca por novos equipamentos na rede, utilizando o protocolo FDL_Status.",
  HSA_POPUP_2: "Utilizado também para detecção de mestres classe 2 ou redes com mais de um mestre.",

  // ---------------------------- Live List ----------------------------
  AVAILABILITY: "Disponibilidade",
  TAG: "Tag",
  ACTIVE: "Ativo",
  INACTIVE: "Inativo",
  REASON: "\nMotivo: ",

  EXPORT_CSV: "Exportar XLSX",
  CSV_HEADER: "Endereço,Tag,Modelo,Diagnósticos,Retentativas sem falhas,Retentativas totais,Falhas,Disponibilidade,Watchdog,Status\n",

  // ---------------------------- Log ----------------------------
  TYPE: "Tipo",
  MANUFACTURER_MODEL: "Fabricante / Modelo",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Ocorreu um erro ao realizar o login: Nome de usuário ou senha incorretos.",
  LOGIN_GENERAL_FALIURE: "Ocorreu um erro ao realizar o login:",

  GPG_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .gpg",
  SEND_FILE_FAILURE: "Ocorreu um erro ao enviar o arquivo.",
  SEND_FILES_SUCCESS: "Os arquivos foram enviados com sucesso.",
  SEND_FILE_WAITING: "Enviando o arquivo.",
  SEND_FILE_WRONG_FILENAME: "Nome inválido. O arquivo de atualização deve chamar-se: updatePB.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "O arquivo de atualização foi corrompido durante o envio.",
  SEND_CONFIG_SUCCESS: "As configurações foram enviadas com sucesso.",
  SEND_CONFIG_FAILURE: "Ocorreu um erro ao enviar as configurações.",
  SEND_CONFIG_WAITING: "Enviando as configurações.",
  SEND_CONFIG_WAITING_2: "Finalizando envio das configurações.",
  SEND_CONFIG_DONE: "Configurações enviadas.",
  SEND_NTP_CONFIG_WAITING: "Enviando as configurações do servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configurações do servidor NTP enviadas.",

  WAITING: "Aguarde um instante",
  CLEAN_LOG_SUCCESS: "O log foi limpado com sucesso.",
  CLEAN_LOG_FAILURE: "Ocorreu um erro ao limpar o log.",
  CLEAN_STATISTICS_SUCCESS: "As estatísticas foram limpadas com sucesso.",
  CLEAN_STATISTICS_FAILURE: "Ocorreu um erro ao limpar as estatísticas.",

  CHANGE_USERNAME_SUCCESS: "O Nome de usuário foi alterado com sucesso. Por favor realize o login novamente.",
  CHANGE_USERNAME_FAILURE: "Ocorreu um erro ao alterar o nome de usuário: ",
  USERNAME_TOO_SHORT: "O nome de usuário precisa conter pelo menos um caractere.",
  PASSWORD_MISSMATCH: "As senhas digitadas não coincidem",
  CHANGE_PASSWORD_SUCCESS: "A senha foi alterada com sucesso. Por favor realize o login novamente.",
  CHANGE_PASSWORD_FAILURE: "Ocorreu um erro ao alterar a senha: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique as seguintes informações:",
  INVALID_IP: "\n- O IP inserido é inválido",
  INVALID_SUBMASK: "\n- A máscara inserida é inválida",
  INVALID_GATEWAY: "\n- O gateway inserido é inválido",
  INVALID_DNS: "\n- O DNS inserido é inválido",
  LOOPBACK_IP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do monitor",
  LOOPBACK_IP_NTP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do servidor NTP",
  SELECT_TIMEZONE: "\n- É necessário selecionar uma Timezone para configurar o servidor NTP",
  SAME_SUBNET_IP_1: "\n- O endereço IP da interface WLAN não pode estar na mesma subrede da interface ETHERNET.",
  SAME_SUBNET_IP_2: "\n- O endereço IP da interface ETHERNET não pode estar na mesma subrede da interface WLAN.",
  SUBNET_OVERLAP_WLAN: "\n- O TS Monitor PROFIBUS detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a WLAN com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- O TS Monitor PROFIBUS detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a interface ETHERNET com o endereço IP e máscara escolhidos.",
  ZERO_IP_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como IP do TS Monitor PROFIBUS",
  ZERO_IP_MASK_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como máscara da rede",
  BROADCAST_IP_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do TS Monitor PROFIBUS",
  NETWORK_IP_MSG: "\n- O IP da rede não pode ser utilizado como IP do TS Monitor PROFIBUS",
  BROADCAST_GATEWAY_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do gateway",
  NETWORK_GATEWAY_MSG: "\n- O IP da rede não pode ser utilizado como IP do gateway",

  EMPTY_WIFI_PWD: "\n- A senha da Wi-fi não pode ser vazia",

  ALTER_USERNAME: "ALTERAR USUÁRIO",
  ALTER_PASSWORD: "ALTERAR SENHA",

  RESTART_SYSTEM: " Reiniciar sistema",
  CONFIRM_RESTART_SYSTEM: "Tem certeza que deseja reiniciar o sistema?",
  RESTART_SYSTEM_FAILURE: "Ocorreu um erro ao tentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Pedido de reinicialização enviado com sucesso. Aguarde cerca de 3 minutos para que o sistema seja reiniciado completamente.",

  SELECT_FILE: "Por favor selecione um arquivo para ser enviado",
  SELECT_GSD_FLIE: "Por favor selecione ao menos um arquivo GSD para ser enviado",
  SENDING_GSD_FILES: "Enviando arquivos GSD",

  DO_NOT_CLOSE_THIS_TAB: "Deixe esta aba aberta para acompanhar a atualização.",
  UPDATING_MONITOR_FILES: "Atualizando arquivos no monitor. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Arquivos atualizados, preparando para reiniciar o monitor.",
  RESTARTING_MONITOR_WAIT: "Reiniciando o monitor, aguarde alguns minutos.",
  UPDATE_SUCCESS: "A atualização foi realizada com sucesso!",
  UPDATE_ERROR_STRING: "Ocorreu o seguinte erro ao atualizar o monitor: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique pelo menos um dos campos para atualizar as configurações de interface.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique pelo menos um dos campos para atualizar as configurações WLAN.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "A tag do monitor foi modificada com sucesso.",
  TAG_CHANGE_FAILURE: "Ocorreu um erro ao modificar a tag do monitor.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nLembre-se de atualizar o endereço no navegador para: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "As configurações de interface foram atualizadas com sucesso!",
  UPDATE_WLAN_CONFIG_SUCCESS: "As configurações de WLAN foram atualizadas com sucesso!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocorreu um erro ao enviar os seguintes arquivos GSD: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocorreu um erro ao remover os seguintes arquivos GSD: ",

  MANAGE: "Gerenciar",

  TAG_CONFIG: "Tag da rede",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuração da interface Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do monitor.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuração da interface sem fio, quando adaptador disponível.",
  WLAN_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do monitor.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Ligar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "Tem certeza que deseja ligar o servidor NTP? Para isso o monitor precisará ser reiniciado.",

  NTP_INFO_TURNED_ON_FAILURE: "Ocorreu um erro ao ligar o servidor NTP.",

  PROCESSING_NTP_INIT: "Iniciando processamento das informações do servidor NTP",
  PROCESSING_NTP_INFO: "Processando as informações do servidor NTP.",
  PROCESSED_NTP_INFO: "Informações do servidor NTP processadas.",
  PROCESSING_NTP_ERROR: "Ocorreu um erro ao enviar as informações para o servidor NTP. Verifique se o endereço IP do servidor está correto. Caso estiver, verifique também se o serviço de NTP está ligado e tente novamente.",

  MONITOR_RESTART_SUCCESS: "O monitor foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE: "Ocorreu um erro ao reiniciar o monitor.",

  NTP_INFO_TURNED_OFF_FAILURE: "Ocorreu um erro ao desligar o servidor NTP.",
  NTP_INFO_FAILURE: "Falha ao sincronizar com o servidor. Caso o erro persista entre em contato com o administrador do servidor NTP.",

  SEND_WLAN_CONFIG_WAITING: "Enviando as configurações, por favor aguarde. Isso pode levar cerca de um minuto.",
  UPDATE_WLAN_CONFIG_ERROR: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o monitor ou o roteador WLAN.",

  ALTER_MONITOR_CONFIG: "Tem certeza que deseja alterar as configurações do monitor?",
  IP: "IP",
  EDIT: "Editar",
  CLEAR: "Limpar",
  ALTER: "Alterar",
  REPORT: "Relatório",
  ALTER_LOGIN: "Alterar login",
  SEND: "Enviar",
  GSD_FILES: "Arquivos GSD",
  SOFTWARE_UPDATE: "Atualização de Software",
  CURRENT_VERSION: "Versão atual: ",
  UPDATE: "Atualizar",

  USER: "Usuário",
  NEW_PASSWORD: "Nova senha",
  REPEAT_PASSWORD: "Repetir senha",
  LOGOUT: "Logout",
  TEST_NETWORK: "Rede de teste",
  TIMEZONE: "Timezone",
  DHCP: "DHCP",
  FIXED_IP: "IP Fixo",

  INTERFACE_CONFIG: "Configurações de Interface",
  LOGIN: "LOGIN",

  ENTER: "Entrar",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha no nível de tensão (Ação Requerida).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha no nível de tensão (Ação Urgente).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "O TS Expert detectou uma possível falha por relé.",
  EVENT_CHECKED_SUCCESS: "O evento foi limpo com sucesso.",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configurações WLAN",
  CONNECTION_STATUS: "Estado da conexão",

  WLAN_ADAPTER_ON: "Ligado",
  WLAN_ADAPTER_OFF: "Desligado",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Força do sinal",
  FREQUENCY: "Frequência",
  CHANNEL: "Canal",
  QUALITY: "Qualidade",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Qualidade",

  TURNING_WLAN_OFF_WAITING: "Desligando o adaptador WLAN, por favor aguarde.",
  TURNING_WLAN_ON_WAITING: "Ligando o adaptador WLAN, por favor aguarde.",

  NETWORK: "Rede",
  NETWORK_NAME_1: "Nome da rede",
  SUBMASK: "Máscara",
  GATEWAY: "Gateway",
  PASSWORD: "Senha",

  ALTER_MONITOR_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do monitor?",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica o estado do adaptador WLAN do monitor.",
  WLAN_STATUS_POPUP_2: "Caso ele esteja desligado não é possível alterar as configurações WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica se o monitor está conectado ou não à rede WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "Não é possível alterar as configurações enquanto o adaptador WLAN estiver desligado.",
  WLAN_CONFIG_POPUP_2: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o monitor por meio da rede cabeada.",
  WLAN_CONFIG_POPUP_3: "Ao alterar o IP / máscara, caso os campos apareçam em branco após a atualização isso é um forte indicativo de que:",
  WLAN_CONFIG_POPUP_4: "Já existe um outro dispositivo na rede com o mesmo IP;",
  WLAN_CONFIG_POPUP_5: "A máscara de rede é muito restrita e não comporta o IP que foi passado.",

  WLAN_ADAPTER_NOT_FOUND_1: "O TS Monitor PROFIBUS não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique se o adaptador está desconectado, ou com mal contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Caso o adaptador não esteja desconectado nem com mal contato, tente substituí-lo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Se nenhuma das opções anteriores solucionar o problema entre em contato com a Toledo e Souza.",

  LOADING_WAITING: "Carregando informações, por favor aguarde.",
  WLAN_INFO: "Informações WLAN",
  MAC: "MAC",
  DNS: "DNS",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "Tem certeza que deseja alterar o hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "Para isso é necessário reiniciar o monitor.",
  HOSTNAME_POPUP_1: "Um hostname deve possuir entre 2 e 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Além disso, ele pode conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  INVALID_HOSTNAME_1: "O hostname deve possuir entre 2 e 64 caracteres.",
  INVALID_HOSTNAME_2: "O hostname deve conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  HOSTNAME_CONFIG_SUCCESS: "O hostname foi configurado com sucesso.",
  HOSTNAME_CONFIG_ERROR: "Ocorreu um erro ao configurar o hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",

  HOSTNAME: "Hostname",

  // ---------------------------- Edit Tags page related ----------------------------
  TAGS: "Tags",
  ADD_ALTER_TAGS: "Adicionar/Alterar Tags",
  CHOOSE_DEVICE: "Escolha um dispositivo",
  NEW_TAG: "Nova TAG",
  SAVE: "Salvar",
  REMOVE_ALL_TAGS: "Remover todas as Tags",
  REMOVE: "Remover",
  CONFIRM_REMOVE_ALL_TAGS: "Tem certeza que deseja remover as tags de todos os dispositivos?",
  CHANGE_TAG_SUCCESS: "A tag foi alterada com sucesso.",
  CHANGE_TAG_FAILURE: "Ocorreu um erro ao alterar a tag",
  REMOVE_TAG_SUCCESS: "As tags foram removidas com sucesso.",
  REMOVE_TAG_FAILURE: "Ocorreu um erro ao remover as tags",
  IMPORT_TAGS_SUCCESS: "As tags foram importadas com sucesso",
  IMPORT_TAGS_FAILURE: "Ocorreu um erro ao importar as tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor selecione um arquivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  // ---------------------------- Edit GSD page related ----------------------------
  REMOVE_GSD_SUCCESS: "Os arquivos GSD foram removidos com sucesso",
  REMOVE_GSD_FILES: "Gerenciar arquivos GSD",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor selecione ao menos um arquivo para remover",
  REMOVING_GSD_FILES: "Removendo arquivos GSD",
  FILTER_GSD_FILES: "Filtrar arquivos GSD",
  SELECT_ALL: "Selecionar todos",
  REMOVER_SELECIONADOS: "Remover selecionados",

  // ---------------------------- Blacklist page related ----------------------------
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "Ocorreu um erro ao adicionar os escravos à blacklist.",

  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "Ocorreu um erro ao remover os escravos da blacklist.",

  REMOVE_CRITIC_DEVICES_FROM_BLACKLIST_FAILURE: "Ocorreu um erro ao remover os escravos da lista de escravos críticos.",

  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por endereço, tag ou modelo",
  BLACKLIST_ADDRESS: "Endereço",
  BLACKLIST_TAG: "Tag",
  BLACKLIST_MODEL: "Modelo",
  BLACKLIST_CRITICAL_SLAVE: "Escravo crítico",
  UPDATE_BLACKLIST: "Atualizar blacklist",
  UPDATING_BLACKLIST_DATA: "Atualizando informações, aguarde",

  BLACKLIST_HEADER_CELL_POPUP: "Impede a gravação de logs de determinado equipamento a fim de não gerar eventos repetitivos ou indesejados.",
  BLACKLIST_HEADER_CELL_POPUP_2: "O escravo em Blacklist não altera o estado da rede na aba Resumo. Suas falhas, retentativas e diagnósticos são contabilizados.",

  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP: "Escravos que apresentam altas quantidades de eventos são inseridos automaticamente na lista de escravos críticos. Seus eventos deixam de ser salvos a fim de não saturar o log, mas suas falhas, retentativas e diagnósticos são contabilizados.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_2: "O usuário pode remover escravos críticos, mas não inserí-los.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_3: "Se existir ao menos um escravo crítico na lista, ele altera o estado da rede para ESCRAVO CRÍTICO na aba Resumo.",

  CONFIRM_ALTER_BLACKLIST: "Tem certeza que deseja realizar as alterações à blacklist e à lista de escravos críticos?",

  // ---------------------------- PDF Report ----------------------------
  REPORT_TYPE: "Tipo de Relatório",

  PROJECT_NAME_LABEL: "Nome do projeto",
  NETWORK_LABEL: "Nome da rede",
  LOCATION_LABEL: "Localização",
  COMPANY_NAME_LABEL: "Nome da empresa",
  ACCOUNTABLE_NAME_LABEL: "Nome do responsável",
  CITY_LABEL: "Cidade",
  TEL_LABEL: "Telefone",
  CLIENT_LOGO_LABEL: "Logo do cliente",
  EMAIL_LABEL: "E-mail",
  EXECUTING_COMPANY_LOGO_LABEL: "Logo da empresa executora",
  FINISHING: "Finalizando...",
  SAVE_REPORT: "Salvar relatório",

  PROFIBUS: "PROFIBUS",

  REPORT_EXPORT_NAME: "Relatório TS Monitor PROFIBUS",
  HEADER_TEXT: "Relatório de dados - TS Monitor PROFIBUS",

  GENERATING_REPORT_WAITING: "Gerando relatório, por favor aguarde",
  GENERATING_REPORT_SUCCESS: "Relatório gerado com sucesso. Para salvá-lo, clique em salvar relatório abaixo.",

  CONFORMITY: "Conformidade",
  DROPDOWN_PLACEHOLDER: "Escolha uma opção",
  GENERATE_REPORT: "Gerar relatório",

  GENERAL_REPORT: "Relatório geral – TS Monitor PROFIBUS",
  DATA_REPORT: "Relatório de dados – TS Monitor PROFIBUS",

  MONITORING_INFO: "Informações do monitoramento",
  ETHERNET_INFO: "Informações ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",

  CLIENT_INFO: "Informações do cliente",
  EXECUTING_COMPANY_INFO: "Informações da empresa executora",
  ANNOTATIONS: "Anotações",
  CONCLUSION: "Conclusão",

  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme com restrições",
  NON_CONFORM_STRING: "Não conforme",

  PROJECT_NAME: "- Nome do projeto:",
  NETWORK_NAME: "- Nome da rede:",
  LOCATION: "- Localização:",
  COMPANY_NAME: "- Nome da empresa:",
  ACCOUNTABLE_NAME: "- Nome do responsável:",
  COMPANY_ADDRESS: "- Endereço:",
  COMPANY_CITY: "- Cidade:",
  COMPANY_TEL: "- Telefone:",

  EXECUTING_COMPANY_NAME: "- Nome da empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nome do responsável:",
  EXECUTING_TEL: "- Telefone:",
  EXECUTING_EMAIL: "- Email:",

  NETWORK_NAME_DP: "- Nome da rede: ",
  TAG_NAME_DP: "- Tag da rede: ",
  MONITOR_VERSION_DP: "- Versão do monitor: ",
  MONITOR_INIT_DP: "- Inicio do monitoramento: ",
  GENERATING_TIME_DP: "- Geração do relatório: ",
  DURATION_SINCE_MON_BEGIN: "- Duração do monitoramento até a geração do relatório: ",

  TS_MONITOR_VER_DP: "TS Monitor PROFIBUS - Versão ",
  NETWORK_AVAILABILITY_DP: "Disponibilidade da rede: ",
  BAUD_RATE_DP: "Baud rate: ",
  CYCLE_TIME_DP: "Tempo de ciclo: ",
  DEVICE_DATA: "Dados dos dispositivos",
  MASTERS_DP: "Mestres: ",
  SLAVES_DP: "Escravos: ",
  ONLINE_SLAVES_DP: "Escravos online: ",
  MISSING_DP: "Ausentes: ",
  RETRIES_DP: "Retentativas: ",
  DIAGNOSTIC_DP: "Diagnósticos: ",
  FAULT_DP: "Falhas: ",
  WATCHDOG_DP: "Watchdog: ",
  RETRIES_LIMIT_DP: "Limite de retentativa: ",
  HSA_DP: "HSA: ",

  SUMMARY: "Sumário",
  RESUME: "Resumo",
  LIVE_LIST: "Live List",
  LOG: "Log",
  MATRIX: "Matriz",
  GRAPHIC_TOPOLOGY: "Topologia gráfica",
  CONFIG_STRING: "Configurações",

  RESUME_DOTS: ".......................................................................................................................................",
  LIVE_LIST_DOTS: ".......................................................................................................................................",
  MON_LOG_DOTS: "...............................................................................................................................................",
  DISCLAIMER_DOTS: "...................................................................................................................................",

  M_MONITORING_RESUME_PAGE_TITLE: "1. - Resumo",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "2. - Live List",
  M_MONITORING_LOG_PAGE_TITLE: "3. - Log",

  OPTIC_FIBER_PAGE_TITLE: "1. - Fibra Ótica",
  OPTIC_FIBER_LOG_PAGE_TITLE: "2. - Log",
  OPTIC_FIBER_DOTS: "...................................................................................................................................",
  OPTIC_FIBER_1_DOTS: "................................................................................................................",
  MONITORING_DOTS: ".................................................................................................................",

  SELECT_REPORT_TYPE: "Por favor selecione um tipo de relatório",

  ADDRESS: "Endereço",
  MODEL: "Modelo",

  LAST_200_EVENTS: "200 últimos eventos",
  HORARY: "Horário",
  DESCRIPTION: "Descrição",

  END_OF_REPORT: "Fim do relatório",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Os dados e valores apresentados neste relatório são meramente auxiliares para o especialista em PROFIBUS, de tal sorte que qualquer indicação de correção deve ser feita pelo usuário. Por esta razão, recomenda-se acompanhamento de engenheiro certificado PROFIBUS ou técnico responsável pela análise para atestar as informações prestadas pelo produto. Portanto a Toledo & Souza se exime de quaisquer responsabilidades, perdas ou danos, diretos ou indiretos causados pelas interpretações do software, não oferecendo nenhuma garantia em relação à integridade, qualidade ou adequação das informações prestadas, pois dependem da análise técnica de um profissional capacitado, sendo que na falta deste, o usuário assumirá o risco de que o conteúdo possa ser impreciso, incompleto ou possa não atender às suas necessidades e requisitos.",

  DIAGNOSTIC_STRING: "Diagnóstico",
  ONLINE_STRING: "Online",
  MISSING_PLURAL_STRING: "Ausentes",
  MISSING_SINGULAR_STRING: "Ausente",
  CONFIG_ERROR_STRING: "Erro de configuração",
  PARAM_ERROR_STRING: "Erro de parametrização",
  FAULT_STRING: "Falha",
  BLACKLIST_STRING: "Blacklist",
  CRITIC_SLAVE_STRING: "Escravo crítico",
  MASTER_FAULT_STRING: "Mestre",
  SLAVE_MASTER_FAULT_STRING: "Mestre em falha",
  MPI_STRING: "MPI",
  MPI_CSV_FAULT_STRING: "MPI em falha",
  MASTER_CLASS_2: "Mestre",
  MASTER_OPERATE: "Mestre - operate",
  MASTER_SYNC: "Mestre - sync",
  MASTER_UNSYNC: "Mestre - unsync",
  MASTER_FREEZE: "Mestre - freeze",
  MASTER_UNFREEZE: "Mestre - unfreeze",
  MASTER_CLEAR: "Mestre - clear",
  CLASS_2: "",
  MASTER_OPERATE_CAPITAL: "Mestre - Operate",
  MASTER_SYNC_CAPITAL: "Mestre - Sync",
  MASTER_UNSYNC_CAPITAL: "Mestre - Unsync",
  MASTER_FREEZE_CAPITAL: "Mestre - Freeze",
  MASTER_UNFREEZE_CAPITAL: "Mestre - Unfreeze",
  MASTER_CLEAR_CAPITAL: "Mestre - Clear",

  PAGE: "Página",

  YEAR: " ano",
  MONTH: " mês",
  MONTHS: " mêses",
  DAY: " dia",
  HOUR: " hora",
  MINUTE: " minuto",
  SECOND: " segundo",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Anterior à última inicialização",
  REMOVE_DEVICE_SUCCESS: "O dispositivo será removido em até 30 segundos.",
  REMOVE_DEVICE_FAILURE: "Ocorreu um erro ao remover o dispositivo: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "A rede possui escravos em diagnóstico",
  WITH_FAILURE_STRING: "A rede possui escravos em falha",
  WITH_CRITICAL_SLAVE_STRING: "A rede possui escravos em estado crítico",
  WITH_MASTER_FAULT_STRING: "A rede possui mestres em falha",
  UNKNOWN: "Desconhecido",
  LOG_WAITING: "Carregando dados do log",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço ou status",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço, tag, modelo ou \"Evento da rede\"",
  OPTIC_FIBER_LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por tipo de evento",
  OPTIC_FIBER_INSERT_VALID_TYPE: "Favor digite um tipo de evento válido.",
  SLAVE_DIAGNOSTIC: "Diagnóstico do escravo:",
  STATUS_CHANGE: "Mudança de estado: ",
  NETWORK_EVENT: "Evento da rede",
  MASTER_HASHTAG: "Mestre #",
  SLAVE_HASHTAG: "Escravo #",
  CONFIG_ERROR_1: "Erro de ",
  CONFIG_ERROR_2: "configuração",
  PARAM_ERROR_1: "Erro de ",
  PARAM_ERROR_2: "parametrização",
  LAST_EVENT: "Último evento: ",

  DIAGNOSTICS_STRING: "Diagnósticos",
  RETRIES_STRING: "Retentativas",
  NO_FAULTS_STRING: "sem falhas",
  TOTAL: "totais",
  RETRIES_NO_FAULT_STRING: "Retentativas sem falhas",
  FAULTS_STRING: "Falhas",
  WATCHDOG_STRING: "Watchdog",
  BILLION_OF: "Bilhão de",
  BILLIONS_OF: "Bilhões de",
  MILLION_OF: "Milhão de",
  MILLIONS_OF: "Milhões de",
  THOUSAND: "Mil",
  LAST_EVENT_TOO_BIG_STRING: "Descrição muito longa, favor consultar o log.",
  CRITICAL_SLAVE_EXPLANATION: "O TS monitor possui uma função automática de selecionar os escravos que possuam um número excessivo de eventos e informa ao usuário que este dispositivo é crítico à rede PROFIBUS.",
  DIAGNOSTICS_QUESTION_INFO: " Indica o número de diagnósticos detectados na rede PROFIBUS. Diagnósticos indicam condições anormais de estado do dispositivo, como curto-circuito, problema de alimentação, falta de módulo, etc.",
  RETRIES_QUESTION_INFO: "Indica o número de vezes que o mestre precisou reenviar ums mensagem para determinado equipamento após não receber resposta. Indica, usualmente, problemas no meio físico.",
  FAULTS_QUESTION_INFO: "Indica o número vezes que determinado equipamento PROFIBUS parou de responder mensagens do mestre.",
  NOT_RETRIES_QUESTION_INFO: "A retentativa sem falha nos ajuda a verificar problemas de rede, que ainda não causaram a queda do dispositivo. Também, desconsidera as quedas que ocorreram por desligamento ou desconexão.",

  WATCHDOG_QUESTION_INFO_1: "O watchdog é o tempo que o escravo aguarda após perder a comunicação com o mestre até modificar suas saídas para a condição de segurança.",
  WATCHDOG_QUESTION_INFO_2: "Este parâmetro é enviado pelo mestre a todos os escravos da rede, individualmente, em seu respectivo telegrama de parametrização.",
  WATCHDOG_QUESTION_INFO_3: "Se o tempo de ciclo estiver próximo ao watchdog a rede fica mais vulnerável.",
  WATCHDOG_QUESTION_INFO: "Indica se o watchdog para o dispositivo está ativo, inativo, ou se ainda não foi parametrizado.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Pesquisar device por endereço ou tag",

  EDIT_TOPOLOGY_POS_STRING: "Editar",
  EDIT_EDGE_TYPE: "Editar tipo de conexão",
  SAVE_TOPOLOGY_POS_STRING: "Salvar",
  DELETE_TOPOLOGY_POS_STRING: "Remover",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topologia",
  IMPORT: "Importar",
  IMPORT_TOPOLOGY: "Importar Topologia",
  POSITION: "Posição",
  EXPORT: "Exportar",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi salvo com sucesso!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao salvar o posicionamento da topologia: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi removido com sucesso!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao remover o posicionamento da topologia: ",

  ASK_REMOVE_POSITIONING: "Tem certeza que deseja remover o posicionamento salvo?",
  REMOVE_POSITIONING: "Remover posicionamento",

  YES: "Sim",
  NO: "Não",

  ALERT_NOT_POSSIBLE_TO_EDIT: "Não é possível editar dados do mestre",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "Não é possível editar os dados do TS Scope",
  ALERT_NOT_POSSIBLE_TO_DELETE: "Não é possível remover um device da live list",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor escolha um tipo de dispositivo",
  ALERT_CHOOSE_CONNECTION_TYPE: "Por favor selecione um tipo de conexão",

  ADD_DEVICE: "Adicionar dispositivo",
  TAG_PLACEHOLDER: "TAG (opcional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de dispositivo",
  ADD_CONNECTION: "Adicionar conexão",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de conexão",
  EDIT_DEVICE: "Editar dispositivo",

  CANCEL: "Cancelar",
  ADD: "Adicionar",

  MASTER_NAME: "Mestre",
  SLAVE_NAME: "Escravo",
  SLAVE_PA_NAME: "Escravo PA",
  REPEATER_NAME: "Repetidor",
  HUB_NAME: "Hub",
  JB_NAME: "Junction Box",
  COUPLER_PROXY_NAME: "Coupler/Proxy",
  FIBER_LINK_NAME: "Link de fibra",
  ACTIVE_TERMINATION_NAME: "Terminador ativo",
  UNKNOWN_NAME: "Desconhecido",
  TS_MONITOR_NAME: "TS Monitor",
  MPI_NAME: "MPI",
  TS_SCOPE_DP_NAME: "TS Scope DP",
  TS_SCOPE_PA_NAME: "TS Scope PA",

  LOCALE_EDIT: "Editar",
  LOCALE_DEL: "Remover selecionado",
  LOCALE_BACK: "Voltar",
  LOCALE_ADD_NODE: "Adicionar dispositivo",
  LOCALE_ADD_EDGE: "Adicionar conexão",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  LOCALE_EDIT_EDGE: "Editar conexão",
  LOCALE_ADD_DESCRIPTION: "Clique em um espaço em branco para adicionar um novo dispositivo",
  LOCALE_EDGE_DESCRIPTION: "Clique em um dispositivo e arraste a conexão até outro dispositivo para conectá-los",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Clique nos pontos de controle e os arraste para um dispositivo para conectá-los",
  LOCALE_CREATE_EDGE_ERROR: "Não é possível criar conexão para um cluster",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters não podem ser removidos",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters não podem ser editados",

  FORM_NO_DEVICE_FOUND_PREFIX: "O dispositivo de endereço ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " não foi encontrado",

  INSERT_VALID_ADDRESS_OR_TAG: "Favor digitar um endereço ou tag válidos",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Favor digitar um endereço, tag ou modelo válidos",

  POSITIONING_CONFLICT_1: "Há um conflito nas informações dos dispositivos de endereços:",
  POSITIONING_CONFLICT_2: "\nPor conta disso, suas posições e conexões voltarão ao estado padrão.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Posicionamentos e conexões retornados ao estado padrão com sucesso",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "Ocorreu o seguinte erro ao retornar os posicionamentos e conexões ao estado padrão: ",

  TOPOLOGY_IMPORT_SUCCESS: "A topologia foi importada com sucesso!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocorreu um erro ao importar a topologia gráfica: ",
  INVALID_OR_CORRUPT_FILE: "O arquivo não é válido ou está corrompido.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor selecione um arquivo de topologia.",

  COLORS_LABELS: "Legenda de cores",
  LABEL_SLAVE_OK_MASTER_OP: ": Escravo ok, e mestre em operate;",
  LABEL_MASTER_STOP_CLEAR: ": Mestre em STOP / CLEAR;",
  LABEL_SLAVE_DIAG: ": Escravo em diagnóstico;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Escravo em falha, e mestre em falha;",
  LABEL_SLAVE_CONFIG_ERROR: ": Escravo com erro de configuração;",
  LABEL_SLAVE_PARAM_ERROR: ": Escravo com erro de parametrização;",
  LABEL_SLAVE_ONLINE: ": Escravo online;",
  LABEL_SLAVE_MISSING: ": Escravo ausente;",
  LABEL_SLAVE_MASTER_FAULT: ": Escravo com mestre em falha;",
  LABEL_SLAVE_BLACKLIST: ": Escravo na blacklist;",
  LABEL_CRITICAL_SLAVE: ": Escravo critico;",
  LABEL_MPI: ": MPI;",
  LABEL_NO_STATUS: ": Dispositivo sem status.",

  DEVICE_TAG_NOT_FOUND: "Não foi encontrado nenhum dispositivo com a TAG: ",

  INSERT_VALID_ADDRESS_1_127: "Digite um endereço de escravo válido, entre 1 e 127.",
  DEVICE_WITH_ADDRESS: "O dispositivo de endereço ",
  WAS_SUCCESSFULLY_ADDED: " foi adicionado com sucesso.",
  WAS_SUCCESSFULLY_REMOVED: " foi removido com sucesso.",
  IS_ALREADY_IN_NETWORK: " já está na rede.",
  REMOVE_DEVICE_ERROR: "Ocorreu o seguinte erro ao tentar remover o dispositivo: ",

  TS_SCOPE_NOT_FOUND: "Não foi possível encontrar o TS Scope de IP:",
  INVALID_INSERTED_IP: "O IP inserido é inválido",
  TS_SCOPE_FETCH_SUCCESS: "Fetch do TS Scope deu certo",

  AN_ERROR_OCURRED: "Ocorreu um erro",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  TS_EXPERT: "TS Expert",
  SETUP: "Configurar",

  TS_EXPERT_CONFIGURATION: "Configurações do TS Expert",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Atualizando as configurações do TS Expert, aguarde um instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "As configurações do TS Expert foram salvas com sucesso.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorreu um erro ao salvar as configurações do TS Expert.",

  CONFIG_RETRIES_LIST_HEADER: "Retentativas sem falha",
  CONFIG_RETRIES_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará as retentativas que não levaram a falha, por dispositivo. A retentativa sem falha nos ajuda a verificar problemas de rede, que ainda não causaram a queda do dispositivo. Também, desconsidera as quedas que ocorreram por desligamento ou desconexão.",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnósticos",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os diagnósticos, por dispositivo.",

  CONFIG_FAULT_LIST_HEADER: "Falhas",
  CONFIG_FAULT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todas as falhas, por dispositivo.",

  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Sequência de falhas",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as falhas que ocorreram em sequência em caso de falhas de diversos dispositivos.",

  CONFIG_CONFIG_ERROR_LIST_HEADER: "Erro de configuração",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os dispositivos que apresentam erro de configuração.",

  CONFIG_PARAM_ERROR_LIST_HEADER: "Erro de parametrização",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os dispositivos que apresentam erro de parametrização.",

  CONFIG_MISSING_LIST_HEADER: "Escravo ausente",
  CONFIG_MISSING_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os escravos ausentes.",

  CONFIG_ONLINE_LIST_HEADER: "Escravo online",
  CONFIG_ONLINE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os escravos online.",

  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Escravo crítico",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todos os escravos críticos.",

  CONFIG_MASTER_FAULT_LIST_HEADER: "Mestre em falha",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará quando o TS Monitor não estiver recebendo frames PROFIBUS.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Link de fibra ótica – Falha no nível de tensão (Ação Requerida)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará baixa tensão nas saídas analógicas que indicam a qualidade do sinal recebido pelo link de fibra. Este valor pode ser configurado pelo usuário na tela de configuração do seu TS Scope/Monitor PRO.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Link de fibra ótica – Falha no nível de tensão (Ação Urgente)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará baixa tensão nas saídas analógicas que indicam a qualidade do sinal recebido pelo link de fibra. Este valor pode ser configurado pelo usuário na tela de configuração do seu TS Scope/Monitor PRO.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Link de fibra ótica – Falha por relé",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "Quando ativada esta opção, o TS Expert mostrará falha no link de fibra indicada por relé, que deve estar conectado ao TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de ações - TS Expert - PROFIBUS",

  TS_EXPERT_POPUP_1: "Nesta aba são apresentadas as informações do TS Expert.",
  TS_EXPERT_POPUP_2: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Monitor em redes PROFIBUS.",
  TS_EXPERT_POPUP_3: "De forma automatizada, a manutenção, engenharia e equipes relacionadas podem obter uma lista de ações com diferentes eventos, suas possíveis causas, sugestões de solução e os dispositivos nos quais foram detectados.",
  TS_EXPERT_POPUP_4: "O uso do TS Expert não exclui a necessidade da análise humana e tampouco substitui tais capacidades de criar correlações de dados e interpretação.",

  DETECTED_ON: "Detectado em: ",
  CHECK_YOUR_NETWORK: "Por favor verifique sua rede.",

  EXPORT_ACTIONS_LIST: "Exportar lista de ações",
  GENERATING_ACTIONS_LIST_WAITING: "Gerando PDF de lista de ações, por favor aguarde.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar lista de ações.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Ações",

  NO_PROBLEM_DETECTED: "O TS Expert não detectou nenhum evento na rede.",
  NO_EVENTS_TO_BE_ANALYZED: "Não existem eventos a serem analisados.",

  NO_EVENT_SELECTED: "Nenhum evento selecionado",
  CHOOSE_AN_EVENT: "Escolha um evento para visualizar as ações sugeridas.",

  DETAILING: "Detalhamento",

  CHECKED: "Conferido",
  BATCH_CHECK: "Conferir todos",

  PROBLEM_CHECKED: "O evento foi conferido com sucesso",
  PROBLEM_CHECK_ERROR: "Ocorreu um erro ao conferir o evento.",

  LAST_UPDATED: "Atualizado pela última vez em: ",
  THIS_COMPUTER_TIME: " (Horário deste computador)",

  DEVICE: "Dispositivo",

  ALL_EVENTS_CHECKED: "Todos os eventos foram conferidos com sucesso.",
  _ADDRESS: "• Endereço: ",
  ACTIONS_LIST_EXPORT_NAME: "Lista de ações - TS Expert - PROFIBUS.pdf",
  SAVE_ACTIONS_LIST: "Salvar lista de ações",

  // ---------------------------- RETRIES (TS EXPERT) ----------------------------
  RETRIES_LIST_HEADER: "Existem dispositivos na rede que possuem retentativas sem falhas.",
  DEVICE_WITH_RETRIES: "Dispositivo com retentativas sem falhas.",

  RETRIES_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem retentativas:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois eles ainda possui retentativas\n",

  RETRIES_SUGGESTION_1: "Quando um dispositivo possuir retentativas sem falhas sugere-se:",
  RETRIES_SUGGESTION_2: "As retentativas sem falhas indicam o número de vezes que o mestre precisou reenviar uma mensagem para determinado equipamento após não receber resposta, seja porque o escravo não respondeu ou porque a resposta estava corrompida (frame ilegal ou incompleto), por efeito de ruido, baixo isolamento em escravo ou na infraestrutura do barramento. A retentativa sem falha nos ajuda a verificar problemas de rede, que ainda não causaram a queda do dispositivo. Também, desconsidera as quedas que ocorreram por desligamento ou desconexão.",
  RETRIES_SUGGESTION_3: "Verificar e corrigir a montagem do conector. O TDC-1000 pode lhe ajudar nesta tarefa;",
  RETRIES_SUGGESTION_4: "Verificar danos ao cabo PROFIBUS, como:",
  RETRIES_SUGGESTION_5: "Dobras menores que 10 vezes o raio do condutor;",
  RETRIES_SUGGESTION_6: "Cortes no cabo;",
  RETRIES_SUGGESTION_7: "Torções no cabo;",
  RETRIES_SUGGESTION_8: "Amassados no cabo.",
  RETRIES_SUGGESTION_9: "Estas não conformidades exigem a troca do trecho de cabo (não é possível solucionar a não conformidade desdobrando ou desamassando o cabo);",
  RETRIES_SUGGESTION_10: "Verifique se há cabos de potência próximos a cabos PROFIBUS. Cabos de dados como o PROFIBUS devem estar separados o mais distante possível ou em eletrocalhas/eletrodutos fechados e aterrados, seguindo o mínimo indicado pelas diretrizes de acordo com a classificação do condutor elétrico, norma EN50174;",
  RETRIES_SUGGESTION_11: "Medir corrente de fuga no cabo com um alicate adequado, se medida for maior que 100mA é necessário conferir a equipotencialização e o sistema de aterramento;",
  RETRIES_SUGGESTION_12: "Verificar a qualidade do sinal com um dos equipamentos da Toledo e Souza que possua osciloscópio, que lhe dará dicas segundo as medições realizadas;",
  RETRIES_SUGGESTION_13: "Caso nenhum dos itens acima resolva, e um determinado equipamento esteja apresentando retentativas isoladamente (apenas um determinado escravo apresenta retentativas), sugere-se substituir a interface de rede do escravo.",
  RETRIES_SUGGESTION_14: "O único item que pode ter melhor resultado com a planta rodando é o item “d”, porém o uso do equipamento da Toledo e Souza que possui osciloscópio deve ser realizado com cautela, pois caso a condição sinal esteja muito comprometida pode derrubar a rede.",

  // ---------------------------- DIAGNOSTIC (TS EXPERT) ----------------------------
  DIAGNOSTIC_LIST_HEADER: "Existem dispositivos na rede que possuem diagnósticos.",
  DEVICE_WITH_DIAGNOSTIC: "Dispositivo com diagnósticos",

  DIAGNOSTIC_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem diagnósticos:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui diagnósticos\n",

  DIAGNOSTIC_SUGGESTION_1: "Quando um dispositivo possuir diagnósticos sugere-se:",
  DIAGNOSTIC_SUGGESTION_2: "O estado “Diagnóstico” é uma informação enviada pelo escravo ao mestre, geralmente não é um problema de rede e sim um aviso do escravo que ele está precisando de manutenção ou substituição. Abaixo a lista de ações para resolver o problema:",
  DIAGNOSTIC_SUGGESTION_3: "Caso um escravo apresente diagnóstico verifique a informação enviada e tente solucionar o problema, caso tenha dificuldade em entender o diagnóstico entre em contato com o fabricante do escravo para sanar suas dúvidas antes de uma intervenção;",
  DIAGNOSTIC_SUGGESTION_4: "O número crescente de diagnóstico sem dados de manutenção pode estar ligado diretamente as falhas do dispositivo, pois quando o equipamento volta a comunicar existe um diagnóstico de conferência, que verifica se o escravo está pronto para troca de dados. Verifique se o número de diagnóstico está próximo ao de falhas, neste caso siga o passo-a-passo de testes para falhas.",

  // ---------------------------- FAULT (TS EXPERT) ----------------------------
  FAULT_LIST_HEADER: "Existem dispositivos na rede que possuem falhas.",
  DEVICE_WITH_FAULT: "Dispositivo com falhas",

  FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem falhas:\n",
  S_FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui falhas\n",

  FAULT_SUGGESTION_1: "Quando um dispositivo possuir falhas sugere-se:",
  FAULT_SUGGESTION_2: "O estado “Falha” indica que o escravo parou de comunicar, ou seja deixou de trocar dados com o mestre (caiu da rede). Neste caso não há como determinar o motivo da falha, que pode ser, por exemplo, o rompimento de um cabo ou falta de alimentação elétrica:",
  FAULT_SUGGESTION_3: "Verificar a alimentação do escravo;",
  FAULT_SUGGESTION_4: "Verificar se está conectado à rede (cabo ou fibra óptica);",
  FAULT_SUGGESTION_5: "Verificar a integridade e correta montagem do conector;",
  FAULT_SUGGESTION_6: "Verificar a integridade do cabo;",

  // ---------------------------- FAULT SEQUENCE (TS EXPERT) ----------------------------
  FAULT_SEQ_LIST_HEADER: "Existem dispositivos na rede que possuem sequências de falhas.",
  DEVICE_WITH_FAULT_SEQ: "Dispositivo com sequência de falhas",

  FAULT_SEQ_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem sequência de erros:\n",
  S_FAULT_SEQ_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui sequência de erros\n",

  FAULTS_SEQ_SUGGESTION_1: "No caso de uma falha de dispositivos em sequência sugere-se:",
  FAULTS_SEQ_SUGGESTION_2: "Verificar a alimentação dos escravos que pararam de comunicar;",
  FAULTS_SEQ_SUGGESTION_3: "Verificar a qualidade do sinal no segmento do primeiro escravo que parou de comunicar com um dos equipamentos da Toledo e Souza que possua osciloscópio;",
  FAULTS_SEQ_SUGGESTION_4: "Verificar se estão conectados à rede;",
  FAULTS_SEQ_SUGGESTION_5: "Verificar se algum terminador isolador foi ligado acidentalmente;",
  FAULTS_SEQ_SUGGESTION_6: "Verificar os terminadores de rede deste segmento;",
  FAULTS_SEQ_SUGGESTION_7: "Verificar a integridade do barramento deste segmento;",
  FAULTS_SEQ_SUGGESTION_8: "Verificar falhas potenciais em repetidores, hubs ou links de fibra óptica.",

  // ---------------------------- CONFIG ERROR (TS EXPERT) ----------------------------
  CONFIG_ERROR_LIST_HEADER: "Existem dispositivos na rede com erro de configuração.",
  DEVICE_WITH_CONFIG_ERROR: "Dispositivo com erro de configuração",

  CONFIG_ERROR_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda apresentam erro de configuração:\n",
  S_CONFIG_ERROR_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda apresenta erro de configuração\n",

  CONFIG_ERROR_SUGGESTION_1: "Quando um dispositivo possuir erro de configuração sugere-se:",
  CONFIG_ERROR_SUGGESTION_2: "Ocorre quando o algum escravo que não aceitou a configuração feita no mestre ou SDCD e não entrou em troca de dados, sugestão:",
  CONFIG_ERROR_SUGGESTION_3: "Verifique a configuração no software do software do mestre ou SDCD;",

  // ---------------------------- PARAM ERROR (TS EXPERT) ----------------------------
  PARAM_ERROR_LIST_HEADER: "Existem dispositivos na rede com erro de parametrização.",
  DEVICE_WITH_PARAM_ERROR: "Dispositivo com erro de parametrização",

  PARAM_ERROR_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda apresentam erro de parametrização:\n",
  S_PARAM_ERROR_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do seguinte dispositivo, pois ele ainda apresenta erro de parametrização\n",

  PARAM_ERROR_SUGGESTION_1: "Quando um dispositivo estiver com erro de parametrização sugere-se:",
  PARAM_ERROR_SUGGESTION_2: "Ocorre quando o algum escravo que não aceitou a parametrização feita no mestre ou SDCD e não entrou em troca de dados. A parametrização é uma conferência de ID Number do escravo, ou seja, pode ser que tenha sido instalado um escravo diferente do declarado no sistema. Sugestão:",
  PARAM_ERROR_SUGGESTION_3: "Verifique se o escravo declarado no software do mestre ou SDCD é o mesmo do instalado em campo.",

  // ---------------------------- MISSING (TS EXPERT) ----------------------------
  MISSING_LIST_HEADER: "Existem dispositivos ausentes na rede.",
  DEVICE_MISSING: "Dispositivo ausente",

  MISSING_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão ausentes:\n",
  S_MISSING_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda está ausentes\n",

  MISSING_SUGGESTION_1: "Quando um dispositivo estiver ausente sugere-se:",
  MISSING_SUGGESTION_2: "Ocorre quando o mestre ou SDCD está buscando um escravo na rede mas não recebe resposta. Este escravo foi configurado no projeto, mas não está respondendo na rede ou não esta instalado. Sugestão:",
  MISSING_SUGGESTION_3: "Verifique se o escravo declarado no software do mestre ou SDCD está conectado à rede e alimentado.",
  MISSING_SUGGESTION_4: "Não é indicado deixar o mestre ou SDCD buscando escravos que não serão instalados.",

  // ---------------------------- ONLINE (TS EXPERT) ----------------------------
  ONLINE_LIST_HEADER: "Existem dispositivos online na rede.",
  DEVICE_ONLINE: "Dispositivo online",

  ONLINE_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão online:\n",
  S_ONLINE_INITIAL_ERROR_MSG: "Não foi possível conferir o eventos do dispositivo, pois ele ainda está online\n",

  ONLINE_SUGGESTION_1: "Quando um dispositivo estiver online sugere-se:",
  ONLINE_SUGGESTION_2: "Ocorre quando o mestre ou SDCD encontra um escravo na rede, mas ele não está configurado no sistema. Sugestão:",
  ONLINE_SUGGESTION_3: "Verifique se o escravo deveria estar fora da rede ou se deve ser configurado.",

  // ---------------------------- CRITICAL SLAVE (TS EXPERT) ----------------------------
  CRITICAL_SLAVE_LIST_HEADER: "Existem escravos críticos na rede.",
  DEVICE_IS_CRITICAL_SLAVE: "Dispositivo é um escravo crítico",

  CRITICAL_SLAVE_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda são escravos críticos:\n",
  S_CRITICAL_SLAVE_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda é um escravo crítico\n",

  CRITICAL_SLAVE_SUGGESTION_1: "Quando existirem escravos críticos na rede sugere-se:",
  CRITICAL_SLAVE_SUGGESTION_2: "O TS monitor possui uma função automática de selecionar os escravos que possuam um número excessivo de eventos, e informa ao usuário que este dispositivo é crítico à rede PROFIBUS. Sugestão:",
  CRITICAL_SLAVE_SUGGESTION_3: "Verifique a condição de instalação do escravo;",
  CRITICAL_SLAVE_SUGGESTION_4: "Verificar a alimentação do escravo;",
  CRITICAL_SLAVE_SUGGESTION_5: "Verificar se está conectado à rede de modo correto;",
  CRITICAL_SLAVE_SUGGESTION_6: "Verificar a integridade e correta montagem do conector;",
  CRITICAL_SLAVE_SUGGESTION_7: "Verificar a integridade do cabo;",
  CRITICAL_SLAVE_SUGGESTION_8: "Verificar a condição de qualidade do sinal do escravo com um dos equipamentos da Toledo e Souza que possua osciloscópio;",
  CRITICAL_SLAVE_SUGGESTION_9: "Caso a análise pelo equipamento com osciloscópio não traga a solução, sugere-se substituir a interface de rede.",
  CRITICAL_SLAVE_SUGGESTION_10: "Para retirar o escravo deste estado é necessário entrar em configurações, depois em blacklist e deselecionar o checkbox.",

  // ---------------------------- MASTER FAULT (TS EXPERT) ----------------------------
  MASTER_FAULT_LIST_HEADER: "Existem mestres em falha na rede.",
  DEVICE_IS_MASTER_FAULT: "Dispositivo é um mestre em falha",

  MASTER_FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles não estão recebendo frames PROFIBUS:\n",
  S_MASTER_FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele não está recebendo frames PROFIBUS\n",

  MASTER_FAULT_SUGGESTION_1: "Quando existirem mestre em falha na rede sugere-se:",
  MASTER_FAULT_SUGGESTION_2: "Ocorre quando o TS Monitor PROFIBUS para de ler a rede. Sugestão:",
  MASTER_FAULT_SUGGESTION_3: "Verifique se houve uma falha geral na rede;",
  MASTER_FAULT_SUGGESTION_4: "Verifique se o TS Monitor foi isolado da rede;",
  MASTER_FAULT_SUGGESTION_5: "Verifique se o TS Monitor está corretamente conectado à rede PROFIBUS.",

  VOLTAGE_: "Tensão",
  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_ERROR_MSG: "Não foi possível conferir os eventos, pois o link de fibra ótica ainda está com falha no nível de tensão.",
  S_FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_INITIAL_ERROR_MSG: "Não foi possível conferir o evento, pois o link de fibra ótica ainda está com falha no nível de tensão.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "Quando for detectado link de fibra ótica com falha no nível de tensão sugere-se verificar visualmente:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "Sugere-se consultar o manual do fabricante do link de fibra para conferir o nível de tensão adequado.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_ERROR_MSG: "Não foi possível conferir os eventos, pois o link de fibra ótica ainda está com falha grave no nível de tensão.",
  S_FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_INITIAL_ERROR_MSG: "Não foi possível conferir o evento, pois o link de fibra ótica ainda está com falha grave no nível de tensão.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "Quando for detectado link de fibra ótica com falha grave no nível de tensão sugere-se verificar visualmente:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "Sugere-se consultar o manual do fabricante do link de fibra para conferir o nível de tensão adequado.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_ERROR_MSG: "Não foi possível conferir os eventos, pois ainda está sendo detectado sinal de falha por relé do link de fibre ótica.",
  S_FIBER_SIGNAL_LOSS_INITIAL_ERROR_MSG: "Não foi possível conferir o evento, pois ainda está sendo detectado sinal de falha por relé do link de fibre ótica.",

  FIBER_SIGNAL_LOSS_SUGGESTION_1: "Quando for detectado sinal de falha por relé do link de fibra ótica sugere-se verificar visualmente:",

  FIBER_SIGNAL_LOSS_SUGGESTION_2: "A alimentação do link de fibra;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Verificar as conexões de fibra e cobre;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Verificar a condição das fibras óticas.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_RETRIES_DOTS: "....................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: "......................................................................................................",
  DEVICE_WITH_FAULT_DOTS: ".................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: ".........................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: ".....................................................................................",
  DEVICE_MISSING_DOTS: ".......................................................................................................................",
  DEVICE_ONLINE_DOTS: "..........................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: "..................................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "...............................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "...................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "......................................................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: "...................................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: "......................................................",
  FIBER_SIGNAL_LOSS_DOTS: "..................................................................................................",
  
  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Lista de ações",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Link de fibra ótica – Falha no nível de tensão (Ação Requerida)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Link de fibra ótica – Falha no nível de tensão (Ação Urgente)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Link de fibra ótica – Falha por relé",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha no nível de tensão.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha no nível de tensão.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de link de fibra ótica com falha por relé",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Fibra Ótica",
  RELAY_STATUS: "Status do relé",
  RELAY_SIGNAL: "Sinal do relé",
  MIN: "Mínimo",
  MAX: "Máximo",
  FAULT: "Falha",
  OK: "OK",
  MIN_ANALOG_VALUE: "Valor mínimo analógico",
  MIN_LIMIT_NOT_VALID: "O valor mínimo analógico não é válido",
  STATUS: "Status",
  MAINTENANCE_URGENT: "Valor de Manutenção Urgente",
  MAINTENANCE_REQUIRED: "Valor de Manutenção Requerida",
  DIVERGENCE_MAINTENANCE_VALUE: "O Valor de manutenção requerida não pode ser menor que o de manutenção urgente!",
  INVALID_VALUE: "Valor Invalido",
  STR_LIMIT: "Até",
  GOOD_STRING: "Bom",
  ATTENTION_STRING: "Atenção",
  BAD_STRING: "Ruim",
  NO_SIGNAL_STRING: "Sem sinal",
  UNKNOWN_STRING: "Desconhecido",
  SIGNAL_QUALITY: "Qualidade do sinal",
  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",
  CHANNEL_5: "Canal 5",
  CHANNELS: "Canais",
  RELAY: "Relé",
  VOLTAGE: " V",
  ERROR_REASON: "\nMotivo: ",
  MONITORING: "Protocolo",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Português",
  ENGLISH: "Inglês",
  SPANISH: "Espanhol",
  GERMAN: "Alemão",
  UPDATING_LANGUAGE_WAITING: "Alterando idioma, aguarde um instante",
  UNABLE_TO_ALTER_LANGUAGE: "Não foi possivel alterar o idioma do programa.\n",

  UPDATES_SUCCESS: "Atualizações realizadas com sucesso",
  PS: "Obs:",
  PS_1: "Obs 1:",
  PS_2: "Obs 2:",
  PS_3: "Obs 3:",

  IP_ASSOCIATED_MONITOR: "IP do monitor associado: ",
});

export default Constants;